import { defineMessages } from 'react-intl';

export default defineMessages({
    linesNextRepayment: {
        id: '_.dashboard.status.lines_next_repayment',
        defaultMessage:
            'Your next payment of {amount} will be collected on {date}'
    },
    linesNextRepaymentOverdue: {
        id: '_.dashboard.status.lines_next_repayment_overdue',
        defaultMessage:
            "Your next repayment of {amount} is overdue. Please make a payment or get in touch if you're not able to - we might be able to {unableToPayLink} it."
    },
    unableToPayLink: {
        id: '_.dashboard.status.lines_next_repayment_overdue_unable_to_pay_link',
        defaultMessage:
            'https://support.iwoca.co.uk/en/articles/1608757-what-happens-if-i-m-unable-to-make-an-upcoming-repayment-due-to-the-corona-crisis'
    },
    unableToPayLinkText: {
        id: '_.dashboard.status.lines_next_repayment_overdue_unable_to_pay_link_text',
        defaultMessage: 'delay or reduce'
    }
});
